<template>
  <v-app>
    <v-layout row wrap>
      <v-flex xs2 md2 >
        <v-btn color="primary" dark text  @click="shareLink()">分享連結</v-btn>
      </v-flex>
    </v-layout>

    <list-editor :column-keys="columnKeys"
                 :items="items"
                 :loading="loading"
                 :showSearchBar="true"
                 :showAddButton="false"
                 :show-export-button="false"
                 :show-search-date="true"
                 :showSearchDate="true"
                 :startDate="page.startDate"
                 :endDate="page.endDate"
                 @editData="edit"
                 @changeOption="handleStatus"
                 @searchData="searchData"></list-editor>
    <!--提示-->
    <alert-view :visible="messageDialog.visible"
                :title="messageDialog.title"
                :content="messageDialog.text"
                :show-cancel="true"
                @cancelEvent="messageDialog.cancel"
                @confirmEvent="messageDialog.confirm">
    </alert-view>

    <GoodDealDialog :visible="editDialog.visible" :item="editDialog.item" @closeEvent="editDialog.visible = false"/>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import AlertView from '../../components/AlertView'
import ListEditor from '../../components/ListEditor';
import dateTimeTool from '../../components/dateTimeTool';
import common from '../../mixins/common';
import { saveFastFinanceInfo, searchFastFinanceList } from '../../store/actions';
import GoodDealDialog from '@/components/GoodDealDialog';

export default {
  name: 'GooddealList',
  components: { GoodDealDialog, ListEditor, dateTimeTool, AlertView},
  data(){
    return {
      loading: false,
      items:[],
      searchInfo:{
        keyword:''
      },
      editDialog: {
        visible: false,
        item: null,
      },
      messageDialog: {
        title: '',
        text: '',
        visible: false,
        confirm: () => {
        },
        cancel: () => {
        },
      },
      page:{
        startDate:'',
        endDate:'',
        index: 1,
        limit: 10,
        totalPage: 0,
        totalCount: 0,
        searchBy: 'name',
        searchValue:'',
        sortBy: 'createdDate',
        sortByValue:'DESC'
      },
    }
  },
  async created() {
    this.setDefaultDate();
    await this.fetchAgentList();
    await this.loadData();
  },
  mixins:[common],
  computed: {
    ...mapGetters(['getUserInfo', 'getAgentList']),
    columnKeys() {
      let list =  [
        { value: "edit", text: "編輯", sortable: false, required: false, color: 'primary', isEvent: true },
        { value: 'name', text: '姓名', sortable: true  ,required: true},
        { value: 'cellphone', text: '電話', sortable: false  ,required: true},
        { value: 'memberId', text: '身分證', sortable: true  ,required: true},
        { value: 'contactTime', text: '聯絡時間', sortable: true  ,required: true},
        { value: 'line', text: 'LINE ID', sortable: true  ,required: true},
        { value: 'status', text: '處理狀態', sortable: true  ,required: true, options: [
            { key: 0 , value: '待處理'},
            { key: 1 , value: '缺資料'},
            { key: 2 , value: '進件中'},
            { key: 3 , value: '申覆中'},
            { key: 4 , value: '對保中'},
            { key: 5 , value: '排撥款'},
            { key: 6 , value: '完成案件'},
          ]},
        { value: 'agentId', text: '處理人員', sortable: true  ,required: true, options: this.agentList() },
        { value: 'createdDate', text: '建立時間', sortable: true  ,required: false , disabled: true },
      ];
      return list;
    },
  },
  methods:{
    ...mapActions(['fetchAgentList', 'removeMortgageData','saveContactInfo', 'searchFastFinanceList', 'saveFastFinanceInfo']),
    async shareLink(){
      const link = `https://gooddeal.tw/#/formView?number=${this.getUserInfo.agentId}`;
      this.showMessageDialog(`您的分享已複製到剪貼簿！ \n ${link}`);
      await this.copyLink(link);
    },
    async copyLink(link){
      try {
        await navigator.clipboard.writeText(link);
        console.log('Link copied to clipboard');
      } catch (err) {
        console.error('Failed to copy: ', err);
      }
    },
    edit(item){
      console.log(`edit == ${JSON.stringify(item)}}`);
      this.editDialog.visible = true;
      this.editDialog.item = item;
    },
    agentList(){
      const agents = this.getAgentList.filter(agent=>agent.enable === true
        && (agent.authority === 'staff' || agent.authority === 'manager' || agent.authority === 'accounting'));
      const list = [];
      for (let agent of agents){
        list.push({ key: agent.agentId, value: agent.displayName })
      }
      return list
    },
    setDefaultDate(){
      let todayDate = new Date();
      todayDate.setMonth(todayDate.getMonth() - 1);
      let currentDate = todayDate.toISOString().substr(0, 10);
      const [thisYear, thisMonth, thisDay] = currentDate.split("-");
      this.page.startDate = `${thisYear}-${thisMonth}-01`;

      let futureDate = new Date();
      // 将当前月份加1，下移到下个月
      futureDate.setMonth(futureDate.getMonth() + 1);
      // 再获取天数即取上个月的最后一天的天数
      futureDate.setDate(0);
      let days = futureDate.getDate();

      let endDate = futureDate.toISOString().substr(0, 10);
      const [futureYear, futureMonth, futureDay] = endDate.split("-");

      this.page.endDate = `${futureYear}-${futureMonth}-${days}`;
    },
    searchData(query){
      console.log(`searchData == ${JSON.stringify(query)}`);
      this.page.searchValue = query.keyword;
      this.loadData();
    },
    async loadData(){
      this.loading = true;
      const startDate = `${this.page.startDate} 00:00:00`
      const endDate = `${this.page.endDate} 23:59:59`

      const query = {
        pageIndex: this.page.index,
        limit: this.page.limit,
        orderBy: this.page.sortBy,
        orderByValue: this.page.sortByValue,
        agentId: '',
        startDate,
        endDate,
        searchQuery: [
          { key: 'name' , value: this.page.searchValue },
          // { key: 'cellphone' , value: this.page.searchValue },
          // { key: 'line' , value: this.page.searchValue }
        ]
      };

      const res = await this.searchFastFinanceList(query);
      const results = res.data;
      console.log(`results === ${JSON.stringify( results )}`)

      const totalCount = results.data.header.totalCount;
      const totalPage = results.data.header.totalPage;
      console.log(`totalPage ${totalPage} / totalCount ${totalCount}`);
      this.page.totalCount = totalCount;
      this.page.totalPage = totalPage;
      this.items = results.data.list;

      this.loading = false;
    },
    async handleStatus(item){
      console.log(`handleStatus == ${JSON.stringify(item)}`);
       try {
         const copy = Object.assign({} , item);
         copy.caseId = item.userId;
         const res = await this.saveFastFinanceInfo(copy);
         const result = res.data;
         if (result && result.statusCode === 0 ){
           this.showMessageDialog(result.message);
         } else {
           this.showMessageDialog(result.message);
         }
       } catch (e) {
         this.showMessageDialog(`發生錯誤`);
       }
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/web/GooddealList.vue